import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'

import { fullName, totalCounts } from 'services/invitation_helpers'

import {
  activeInvitationsSelector,
  eventSelector,
  eventTicketCountsSelector,
  hostSelector,
  ticketTypesSelector,
  usersSelector
} from 'src/selectors'

import FloatingButtonSpacer from 'components/common/FloatingButtonSpacer'
import FloatingButtonContainer from 'components/common/FloatingButtonContainer'

import GuestListRowContainer from 'src/components/guest_list/GuestListRowContainer'
import HostRow from 'src/components/guest_list/HostRow'
import HobnobNavBar from 'components/common/HobnobNavBar'

import { sumCount } from '../services/utils'

import styles from './guest-list-page.scss'

class GuestListPage extends React.Component {
  _renderListHeader (label, invitations) {
    const { event } = this.props
    const { child_count_enabled, guest_count_enabled, ticketing_enabled_at } = event
    let guestCounts = 0

    if (ticketing_enabled_at) {
      guestCounts = totalCounts(invitations, guest_count_enabled, true)
    } else {
      guestCounts = totalCounts(invitations, guest_count_enabled, child_count_enabled)
    }

    const showTotalCount = label !== 'Host' && label !== 'Co-Hosts'

    return (
      <div>
        <div className={styles['label']}>
          {label}
          {showTotalCount ? ` - ${guestCounts.totalCount}` : null}
          <div className={styles['label-line']} />
        </div>
      </div>
    )
  }

  _renderList (label, invitations) {
    const { users } = this.props
    if (invitations.length === 0) {
      return null
    }

    const sortedInvitations = invitations.sort((a, b) => {
      const aUser = users[a.guest]
      const bUser = users[b.guest]
      return fullName(a, aUser).localeCompare(fullName(b, bUser))
    })

    return (
      <div>
        {this._renderListHeader(label, invitations)}
        <div className={styles['invitations-list']}>
          {sortedInvitations.map((invitation) => (
            <GuestListRowContainer
              key={invitation.id}
              invitation={invitation}
            />
          ))}
        </div>
      </div>
    )
  }

  render () {
    const {
      event,
      host,
      hostInvitations,
      cohostInvitations,
      acceptedInvitations,
      undecidedInvitations,
      declinedInvitations
    } = this.props

    return (
      <div className={styles['wrapper']}>
        <HobnobNavBar title='Guest List' subTitle={event.name} backPathName='details' />
        <div className={styles['container']}>
          {this._renderListHeader('Host')}
          <HostRow
            user={host}
            invitations={hostInvitations}
            customHostName={event.custom_host_name}
          />

          {this._renderList('Co-Hosts', cohostInvitations)}
          {this._renderList('Attending', acceptedInvitations)}
          {this._renderList('Undecided', undecidedInvitations)}
          {this._renderList('Not Attending', declinedInvitations)}
          <FloatingButtonSpacer />
          <FloatingButtonContainer pageName='Guest List Page' />
        </div>
      </div>
    )
  }
}

GuestListPage.propTypes = {
  event: PropTypes.object,
  host: PropTypes.object,
  hostInvitations: PropTypes.array,
  cohostInvitations: PropTypes.array,
  acceptedInvitations: PropTypes.array,
  undecidedInvitations: PropTypes.array,
  declinedInvitations: PropTypes.array,
  users: PropTypes.object
}

function _getCounts (type, eventTickets, ticketTypes) {
  const guestTicketTypes = ticketTypes.filter((item) => item.label === type)

  let totalCounts = 0
  for (let i = 0; i < guestTicketTypes.length; i++) {
    const typeItem = guestTicketTypes[i]
    const ticket = eventTickets.ticket_counts.filter((item) => item.ticket_type_id === typeItem.id)
    totalCounts = sumCount(ticket, 'ticket_count')
  }
  return totalCounts
}

function accumulateInvitations (invitations, host, eventTicketCounts, ticketTypes) {
  let invs = {
    hostInvitations: [],
    cohostInvitations: [],
    acceptedInvitations: [],
    undecidedInvitations: [],
    declinedInvitations: []
  }

  return invitations.reduce((accumulator, invitation) => {
    if (invitation.guest === host.id) {
      if (eventTicketCounts.ticketing_enabled_at) {
        const eventTicket = eventTicketCounts.invitations.filter((item) => item.id === invitation.id)[0]
        const guestCount = _getCounts('adult', eventTicket, ticketTypes)
        const childCount = _getCounts('child', eventTicket, ticketTypes)

        invitation = {
          ...invitation,
          guest_count: guestCount - 1,
          child_count: childCount
        }
      }
      accumulator.hostInvitations.push(invitation)
    } else if (invitation.cohost) {
      accumulator.cohostInvitations.push(invitation)
    } else {
      switch (invitation.rsvp_state) {
        case 'accepted':
          if (eventTicketCounts.ticketing_enabled_at) {
            const eventTicket = eventTicketCounts.invitations.filter((item) => item.id === invitation.id)[0]
            const guestCount = _getCounts('adult', eventTicket, ticketTypes)
            const childCount = _getCounts('child', eventTicket, ticketTypes)

            invitation = {
              ...invitation,
              guest_count: guestCount - 1,
              child_count: childCount
            }
          }
          accumulator.acceptedInvitations.push(invitation)
          break
        case 'declined':
          accumulator.declinedInvitations.push(invitation)
          break
        case 'undecided':
        default:
          accumulator.undecidedInvitations.push(invitation)
          break
      }
    }

    return accumulator
  }, invs)
}

function mapStateToProps (state) {
  const host = hostSelector(state)
  const eventTicketCounts = eventTicketCountsSelector(state)
  const ticketTypes = ticketTypesSelector(state)
  return {
    event: eventSelector(state),
    host,
    users: usersSelector(state),
    eventTicketCounts,
    ...accumulateInvitations(activeInvitationsSelector(state), host, eventTicketCounts, ticketTypes)
  }
}

export default connect(mapStateToProps)(GuestListPage)



// WEBPACK FOOTER //
// ./src/containers/GuestListPage.jsx